export function attackUrl(userId) {
  return `https://www.torn.com/page.php?sid=attack&user2ID=${userId}`;
}

export function itemMarketUrl(itemId) {
  return `https://www.torn.com/page.php?sid=ItemMarket#/market/view=search&itemID=${itemId}&sortField=price&sortOrder=ASC`;
}
